import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentUser } from '@shared/interfaces';
import { AppRoutes } from '@shared/enums';
import { CurrentUserService } from '@core/services';
import { Router } from '@angular/router';
import { LayoutService } from '@layout/core/services';
import { DecoIconComponent } from '@shared/components/deco-icon/deco-icon.component';
import { HeaderMixpanelService } from '@shared/mixpanel';

@Component({
    selector: 'app-menu-profile[closePopover]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
    standalone: true,
    imports: [TranslateModule, DecoIconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuProfileComponent {
    router = inject(Router);

    closePopover = output<void>();

    currentUser = signal<CurrentUser | null>(this.currentUserService.getCurrentUser());

    readonly appRoutes = AppRoutes;
    readonly accountSettingsUrl = environment.accountsUrl + '/Account/Details';

    constructor(
        private currentUserService: CurrentUserService,
        private layoutService: LayoutService,
        private mixpanel: HeaderMixpanelService
    ) {
        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser.set(user);
        });
    }

    logout(): void {
        this.currentUserService.logout();
    }

    setDisplayImpersonateModal(value: boolean): void {
        if (value && !this.currentUserService.getCurrentUser().isAdmin) {
            return;
        }
        this.layoutService.openImpersonationModal();
    }

    close(): void {
        this.closePopover.emit();
    }

    goToAccountSettings(): void {
        window.open(this.accountSettingsUrl, '_blank');
    }

    goToQuickOrderSettings(): void {
        this.router.navigate([this.appRoutes.ACCOUNT_OVERVIEW]);
    }

    goToBillingSettings(): void {
        this.router.navigate([this.appRoutes.ACCOUNT_PAYMENT_SETTINGS]);
    }

    goToMessageSettings(): void {
        this.router.navigate([this.appRoutes.ACCOUNT_MESSAGES]);
    }

    logAction(action: 'account-settings' | 'quickorder-settings' | 'billing-settings' | 'message-settings') {
        switch (action) {
            case 'account-settings':
                this.mixpanel.logOpenAccountSettings();
                break;
        }
    }
}
